import Chip from '@mui/material/Chip'
import styled from '@emotion/styled'

export const StyledClip = styled(Chip)(({theme}) => ({
  color: theme.palette.hpAccentBlack,
  borderRadius: '8px',
  margin: '4px'
}))
